<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide (){
     return {
       reload:this.reload
     }
  },
  data(){
    return {
       isRouterAlive:true
    }
  },
  methods:{
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
}
</script>

<style lang="less">
html,body{
  width:100%;
  height:100%;
  /* background: #fafafa; */

  background: #ffffff;
}
#app {
  color: #353643;
  font-family: Sofia Pro-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* padding-bottom: 60px; */
  /* background: #fafafa; */

  background: #ffffff;
  overflow:initial;
  height: 100%;
}
*{
  margin:0;
  padding:0;
}
body{
  margin: 0 !important;
  font-family: Sofia Pro-Regular;
}
a{
  text-decoration: none;
}
ul,li{
  list-style:none;
}
/* element-ui 下拉框在ios上 点击两次才能选中 */
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue